import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class FspSharePoint365InfoItem<T extends EMode = EMode.entity> {
  /** Alias: id */
  id?: string;
  /** Alias: url */
  url?: string;
  /** Alias: name */
  name?: string;

  __typename?: string;
}

const fields: FieldDefinitions<FspSharePoint365InfoItem> = {
  id: {
    alias: 'id',
  },
  url: {
    alias: 'url',
  },
  name: {
    alias: 'name',
  },
  __typename: {
    alias: '__typename',
  },
};

export const fspSharePoint365InfoItemEntityDefinition: EntitiyDefinition<FspSharePoint365InfoItem> =
  {
    local: {},
    remote: {
      queryName: 'listSharePointSites',
      fragmentName: 'FspSharePoint365InfoItem',
      withPaginationWrapper: false,
      params: [{ name: 'sharePoint365Config', type: 'InputOneDriveFspConfig' }],
    },
    fieldDefinitions: fields,
  };
